/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenerateSerialNumber
 */
export interface ControlcenterMelcoModelsGenerateSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    referral_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    number_of_licenses?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    version_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsGenerateSerialNumber
     */
    affiliate_code?: string | null;
}

export function ControlcenterMelcoModelsGenerateSerialNumberFromJSON(json: any): ControlcenterMelcoModelsGenerateSerialNumber {
    return ControlcenterMelcoModelsGenerateSerialNumberFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenerateSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenerateSerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'number_of_licenses': !exists(json, 'number_of_licenses') ? undefined : json['number_of_licenses'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'affiliate_code': !exists(json, 'affiliate_code') ? undefined : json['affiliate_code'],
    };
}

export function ControlcenterMelcoModelsGenerateSerialNumberToJSON(value?: ControlcenterMelcoModelsGenerateSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'number_of_licenses': value.number_of_licenses,
        'version_id': value.version_id,
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'affiliate_code': value.affiliate_code,
    };
}


